import React from 'react';
import PropTypes from 'prop-types';

import Popover from 'src/core/gd-components/gd-popover/popover';
import NumberInput from "core/gd-modals/estimate-task/number-input";

export default class SelectProgressPopover extends React.Component {

    static propTypes = {
        form: PropTypes.object,

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        offset: PropTypes.string,
        attachmentType: PropTypes.string,

        getTargetFunc: PropTypes.func,
        onClickOutside: PropTypes.func,
        onSelectorItemClick: PropTypes.func,
        onProgressChange: PropTypes.func
    };

    onSave = () => this.props.form.onSubmitClick()

    render() {
        const presetItems = [{value: null}];
        [0,10,20,30,40,50,60,70,80,90,100].map(val=>{presetItems.push({value:val, label:'{0}%'.f(val)});});
        const value = this.props.form.getValue("progress");

        return (
            <Popover className="gd-progress-popover"
                     attachment={this.props.attachment}
                     targetAttachment={this.props.targetAttachment}
                     attachmentType={this.props.attachmentType}
                     constraints={[{
                         to: "window",
                         attachment: "together",
                         pin: true
                     }]}
                     offset={this.props.offset}
                     getTargetFunc={this.props.getTargetFunc}
                     onClickOutside={this.props.onClickOutside}>

                <div className="ui5-popover-selector progress-selector">
                    <div className="form-line">
                        <div className="label ui5-txt-not-important-small">Progress</div>
                        <div className="element">
                            {presetItems.map((obj, key)=> {
                                if ( _.isNil(obj.value)) {
                                    return (
                                        <div key={key} className="not-set m-b-5" onClick={()=>{this.props.onSelectorItemClick(obj.value)}}>
                                            <div className="ui5-pill-26">Not set</div>
                                        </div>
                                    )
                                } else {
                                    const classes= Classes("ui5-pill-26", "m-r-5",  {
                                        selected: obj.value === value
                                    });
                                    return <div key={key} className={classes} onClick={()=>{this.props.onSelectorItemClick(obj.value)}}>{obj.label}</div>
                                }
                            })}
                        </div>
                    </div>

                    <div className="form-line m-t-5">
                        <div className="label ui5-txt-not-important-small">Custom</div>
                        <div className="element custom-input m-b-15">
                            <NumberInput className="percentage"
                                         value={this.props.form.getValue("progress")}
                                         canEdit={true}
                                         postfix="%"
                                         onChange={this.props.onProgressChange} />
                            <div className="ui5-button primary s30 m-l-10" onClick={this.onSave}>Save</div>
                        </div>
                    </div>
                </div>
            </Popover>
        );
    }
}
